/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Source_Preview_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Please select a file from the menu on the left." |
*
* @param {Plain_Text_Import_Source_Preview_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_source_preview_placeholder = /** @type {((inputs?: Plain_Text_Import_Source_Preview_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Source_Preview_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un fichier dans le menu de gauche.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Datei aus dem Menü auf der linken Seite aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezionare un file dal menu a sinistra.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите файл из меню слева.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un archivo del menú de la izquierda.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请从左侧菜单中选择一个文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左側のメニューからファイルを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया बाईं ओर दिए गए मेनू से एक फ़ाइल चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione um arquivo no menu à esquerda.")
	return /** @type {LocalizedString} */ ("Please select a file from the menu on the left.")
});